import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const PublicSectorTransformation = () => {
  return (
    <>
      <Element
      name="PublicSectorTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Public Sector Transformation"
              />
              <p className="mt-4">AI is transforming public service delivery-from reactive decision-making to predictive, citizen-centered engagement. M2M Tech's privacy-first AI and Edge platforms ensure compliance, transparency, and faster impact.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Manual Tracking → To Automated Sentiment & Risk Monitoring</li>
                <li>From Data Silos → To Real-Time AI Across Departments</li>
                <li>From Cloud Dependence → To Edge AI with Privacy by Design</li>
                <li>From Fragmented Tools → To Unified Dashboards & AI Agents</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4">
                    <h5 className="mtsc-heading mb-0">
                      -40%
                    </h5>
                    <small>Manual Analysis of Public Input</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4">
                    <h5 className="mtsc-heading mb-0">
                      3X
                    </h5>
                    <small>Policy Responsiveness Speed</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4">
                    <h5 className="mtsc-heading mb-0">
                      -35%
                    </h5>
                    <small>Regulatory Review Time</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4">
                    <h5 className="mtsc-heading mb-0">
                      +50%
                    </h5>
                    <small>Citizen Sentiment Visibility</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default PublicSectorTransformation;